module.exports = __webpack_public_path__ + "img/feature-03.fa236aef.png";